export default __webpack_public_path__ + "static/avatar-1-b3536c6891feea8562cc923a45a56445.png";